
import { GET_LIST_LOGS,  GET_FILE_EXPORT } from '@/api/phase2/logs'

export default {
  getListLogs ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_LIST_LOGS({ payload }, successCallback, errorCallback)
  },
  getFileExport ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_FILE_EXPORT({ payload }, successCallback, errorCallback)
  }
};
